<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    上水径站<br>
站点介绍<br>
上水径站位于深圳市布吉街道办西北部, 由布龙路、吉华路、西环路组成交通网络，延吉华路呈东西向布设。车站在联络道与嘉兴北路东侧，东南及东北为上水径居住区，东侧规划办公楼用地，南侧、西侧与北侧均为规划居住用地。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:14	23:21	5号线	3分钟	5分25秒<br>
黄贝岭	06:14	00:00	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:26	23:21	5号线	4分钟	6分钟<br>
黄贝岭	06:08	00:00	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:26	00:21	5号线	4分钟	6分钟<br>
黄贝岭	06:08	01:00	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
C出入口:<br>
吉华路西侧、水径学校、丽湖花园（前行1公里）、中海怡翠（前行1公里）<br><br>
E出入口:<br>
联络道西侧、万科麓城<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 上水径<br>
M105（原K105）、M267、M271、M272、303、307、308、312、381、980、M414、M415<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


